(() => {
  const isEn = document.documentElement.lang === 'en';
  const productTypeAliases = {
    '壺承': '壶承',
    '壶承': '壶承',
    '蓋置': '盖置',
    '盖置': '盖置',
    '茶則': '茶则',
    '茶则': '茶则',
    '茶盤': '茶盘',
    '茶盘': '茶盘'
  };

  const normalizedSearchQuery = (query) => productTypeAliases[query] || query;

  function renderResults(container, source, productType = '') {
    container.replaceChildren();
    [...source.querySelectorAll('[data-search-result], .main-search .prod-card, .collection-product-card')]
      .filter((sourceCard) => !productType || sourceCard.dataset.productType === productType)
      .slice(0, 6)
      .forEach((sourceCard) => {
      const card = document.createElement('a');
      card.className = 'header-search-result';
      const sourceLink = sourceCard.matches('[data-search-result]') ? sourceCard : sourceCard.querySelector('.product-card__link, .prod-img, .prod-name a');
      card.href = sourceLink?.getAttribute('href') || '#';
      if (isEn && card.origin === window.location.origin && /^\/products\//.test(card.pathname)) {
        card.pathname = `/en${card.pathname}`;
      }

      const sourceImage = sourceCard.querySelector('img');
      if (sourceImage) {
        const image = document.createElement('img');
        image.src = sourceImage.currentSrc || sourceImage.src;
        image.alt = sourceImage.alt || '';
        image.loading = 'lazy';
        card.append(image);
      } else {
        const placeholder = document.createElement('span');
        placeholder.className = 'header-search-image-placeholder';
        placeholder.setAttribute('aria-hidden', 'true');
        card.append(placeholder);
      }

      const copy = document.createElement('span');
      copy.className = 'header-search-result-copy';
      const title = document.createElement('span');
      title.className = 'header-search-result-title';
      title.textContent = sourceCard.querySelector('[data-search-result-title], .product-card__title, .prod-name')?.textContent?.trim() || '';
      copy.append(title);
      const priceText = sourceCard.querySelector('[data-search-result-price], .product-card__price, .prod-price')?.textContent?.trim();
      if (priceText) {
        const price = document.createElement('span');
        price.className = 'header-search-result-price';
        price.textContent = priceText;
        copy.append(price);
      }
      if (sourceCard.querySelector('[data-search-result-soldout], .product-card__badge, .badge-soldout')) {
        const soldout = document.createElement('span');
        soldout.className = 'header-search-result-soldout';
        soldout.textContent = (isEn ? "Sold out" : '売り切れ');
        copy.append(soldout);
      }
      card.append(copy);
      container.append(card);
      });
  }

  function initSearchPanel(panel) {
    if (!panel || panel.dataset.initialized === 'true') return;
    panel.dataset.initialized = 'true';
    const form = panel.querySelector('[data-search-form]');
    const input = panel.querySelector('[data-search-input]');
    const clear = panel.querySelector('[data-search-clear]');
    const status = panel.querySelector('[data-search-status]');
    const results = panel.querySelector('[data-search-results]');
    const allResults = panel.querySelector('[data-search-all-results]');
    const openers = [...document.querySelectorAll('[data-search-open]')];
    let opener = null;
    let timer = null;
    let controller = null;

    const setExpanded = (expanded) => openers.forEach((button) => button.setAttribute('aria-expanded', String(expanded)));
    const updateAllResultsLink = (query) => {
      allResults.href = `${panel.dataset.searchUrl}?q=${encodeURIComponent(normalizedSearchQuery(query))}&type=product`;
    };
    const clearResults = (message = '') => {
      results.replaceChildren();
      status.textContent = message;
      allResults.hidden = true;
    };
    const updateResultStatus = () => {
      const count = results.querySelectorAll('.header-search-result').length;
      status.textContent = count ? (isEn ? `${count} objects found.` : `${count}件の作品が見つかりました。`) : (isEn ? "No matching objects found." : '該当する商品が見つかりませんでした。');
      allResults.hidden = count === 0;
    };
    const close = () => {
      if (panel.hidden) return;
      panel.hidden = true;
      controller?.abort();
      window.clearTimeout(timer);
      setExpanded(false);
      opener?.focus();
    };
    const open = (button) => {
      if (!panel.hidden) { close(); return; }
      opener = button;
      if (isEn && button.closest('[data-main-nav]')) {
        document.querySelector('[data-main-nav]')?.classList.remove('open');
        const menuToggle = document.querySelector('[data-nav-toggle]');
        menuToggle?.setAttribute('aria-expanded', 'false');
        opener = menuToggle || button;
      }
      panel.hidden = false;
      setExpanded(true);
      window.setTimeout(() => input.focus(), 0);
    };
    const request = async (query) => {
      controller?.abort();
      controller = new AbortController();
      const signal = controller.signal;
      const searchQuery = normalizedSearchQuery(query);
      const productType = productTypeAliases[query];

      if (productType) {
        try {
          const collectionUrl = `${panel.dataset.collectionUrl}?filter.p.product_type=${encodeURIComponent(productType)}&section_id=main-collection`;
          const response = await fetch(collectionUrl, { signal, headers: { 'X-Requested-With': 'XMLHttpRequest' } });
          if (!response.ok) throw new Error('collection-search-unavailable');
          const markup = await response.text();
          if (signal.aborted) return;
          renderResults(results, new DOMParser().parseFromString(markup, 'text/html'), productType);
          updateResultStatus();
          return;
        } catch (error) {
          if (signal.aborted) return;
        }
      }

      const predictiveUrl = `${panel.dataset.predictiveUrl}?q=${encodeURIComponent(searchQuery)}&resources[type]=product&resources[limit]=6&section_id=predictive-search`;
      try {
        const response = await fetch(predictiveUrl, { signal, headers: { 'X-Requested-With': 'XMLHttpRequest' } });
        if (!response.ok) throw new Error('predictive-search-unavailable');
        const markup = await response.text();
        if (signal.aborted) return;
        renderResults(results, new DOMParser().parseFromString(markup, 'text/html'));
      } catch (error) {
        if (signal.aborted) return;
        try {
          const fallbackUrl = `${panel.dataset.searchUrl}?q=${encodeURIComponent(searchQuery)}&type=product&section_id=main-search`;
          const response = await fetch(fallbackUrl, { signal, headers: { 'X-Requested-With': 'XMLHttpRequest' } });
          if (!response.ok) throw new Error('search-unavailable');
          const markup = await response.text();
          if (signal.aborted) return;
          renderResults(results, new DOMParser().parseFromString(markup, 'text/html'));
        } catch (fallbackError) {
          if (signal.aborted) return;
          status.textContent = (isEn ? "Unable to load results. Please try the search page." : '検索結果を読み込めませんでした。検索ページでお試しください。');
          allResults.hidden = true;
          return;
        }
      }

      updateResultStatus();
    };
    const search = () => {
      const query = input.value.trim();
      clear.hidden = !query;
      updateAllResultsLink(query);
      controller?.abort();
      window.clearTimeout(timer);
      if (query.length < 2) {
        clearResults(query ? (isEn ? "Enter at least two characters." : '2文字以上入力してください。') : '');
        return;
      }
      status.textContent = isEn ? 'Searching…' : '検索中…';
      results.replaceChildren();
      allResults.hidden = true;
      timer = window.setTimeout(() => request(query), 280);
    };

    openers.forEach((button) => button.addEventListener('click', () => open(button)));
    panel.querySelectorAll('[data-search-close]').forEach((button) => button.addEventListener('click', close));
    clear.addEventListener('click', () => { input.value = ''; input.focus(); search(); });
    input.addEventListener('input', search);
    if (isEn) {
      panel.addEventListener('keydown', (event) => {
        if (!['ArrowDown', 'ArrowUp'].includes(event.key)) return;
        const cards = [...results.querySelectorAll('.header-search-result')];
        if (!cards.length) return;
        const index = cards.indexOf(document.activeElement);
        if (index === -1 && document.activeElement !== input) return;
        event.preventDefault();
        const next = index + (event.key === 'ArrowDown' ? 1 : -1);
        if (next < 0) input.focus();
        else cards[Math.min(next, cards.length - 1)].focus();
      });
    }
    form.addEventListener('submit', () => updateAllResultsLink(input.value.trim()));
    document.addEventListener('pointerdown', (event) => {
      if (panel.hidden || panel.contains(event.target) || openers.some((button) => button.contains(event.target))) return;
      close();
    });
    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape' && !panel.hidden) { event.preventDefault(); close(); }
    });
  }

  document.querySelectorAll('[data-search-panel]').forEach(initSearchPanel);
  document.addEventListener('shopify:section:load', (event) => event.target.querySelectorAll?.('[data-search-panel]').forEach(initSearchPanel));
})();
